import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from '../../external-components/angular-material.module';
import { DevextremeModule } from '../../external-components/devextreme.module';
import { SharedModule } from '../shared/shared.module';
import { PipesModule } from '../../pipes/pipes.module';
import { FlexLayoutModule } from 'ng-flex-layout';
import { SignatureBoxComponent } from './signature-box/signature-box.component';
import { SignatureEditSignersComponent } from './signature-edit-signers/signature-edit-signers.component';
import { SignatureBoxFilterComponent } from './signature-box-filter/signature-box-filter.component';
import { ConfirmationDialogSignatureComponent } from './confirmation-dialog-signature/confirmation-dialog-signature.component';


@NgModule({
  declarations: [
    SignatureBoxComponent,
    SignatureEditSignersComponent,
    SignatureBoxFilterComponent,
    ConfirmationDialogSignatureComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    /* Custom modules */
    AngularMaterialModule,
    DevextremeModule,
    SharedModule,
    PipesModule,

    /* Otros */
    FlexLayoutModule
  ]
})
export class SignatureModule { }
